import { createSlice } from '@reduxjs/toolkit'
import { editConfiguration, getConfiguration } from '../../builders/configuration/configuration.builder'


const initialState = {
  configurationData: {},
  loading: null,
}

const configurationSlice = createSlice({
  name: 'configuration',
  initialState,
  reducers: {
    clearExtraReducers: (state) => {
      state.loading = false
      state.configurationData = {}
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getConfiguration.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getConfiguration.fulfilled, (state, action) => {
      state.configurationData = action.payload
      state.loading = false
    })
    builder.addCase(getConfiguration.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(editConfiguration.pending, (state) => {
      state.loading = true
    })
    builder.addCase(editConfiguration.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(editConfiguration.rejected, (state) => {
      state.loading = false
    })
  },
})

export const { configurationData, loading } = configurationSlice.actions

export default configurationSlice.reducer
